
import React, { FC, useState, useEffect } from 'react'
import { KTSVG } from '../../../../_metronic/helpers'
import * as a from '../'

type Props = {
    alertType?: string
    title: string
    content: string
    icon?: any
}

export const AncientAlert: React.FC<Props> = ({ alertType, title, content, children , icon}) => {

    return (
        <div className={`alert ${alertType == undefined ? "alert-primary" : alertType} d-flex align-items-center p-5 mb-10`}>
            <span className="svg-icon svg-icon-2hx svg-icon-primary me-3"><KTSVG path={icon} className='svg-icon-2' /></span>
    
            <div className="d-flex flex-column">
                <h5 className="mb-1">{title}</h5>
                <span>{content}</span>
            </div>
        </div>
    )
}